'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');
const styleEncapsulation = require('@zapier/style-encapsulation');
const theme_Animation = require('../../../theme/Animation.cjs.js');
require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
require('react');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_forms_Input_Input = require('../Input/Input.cjs.js');
const components_forms_DateRangePicker_DateRangePickerValue = require('./DateRangePickerValue.cjs.js');

const Styles = styleEncapsulation.labelStyles("DateRangePickerInput", {
  root: (props) => react.css`
    cursor: ${props.isDisabled ? "default" : "pointer"};
  `,
  button: react.css`
    display: flex;
    align-items: center;
    min-width: 0;

    &[data-size='compact'] {
      font: var(--zds-minimal-print-2);
    }
  `,
  clearSelectionButton: react.css`
    ${styleMixins_reset.interactiveReset}

    align-items: center;
    color: var(--zds-stroke-stronger);
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;

    &:hover,
    &:focus {
      color: var(--zds-text-default);
      transition: ${theme_Animation.Animation.transitionValue};
    }
  `,
  placeholder: react.css`
    color: var(--zds-stroke-stronger);
    display: block;
    overflow: hidden;
    white-space: nowrap;
  `
});
const ClearSelectionButton = ({ clearSelection }) => {
  return react.jsx(
    "button",
    { type: "button", css: Styles.clearSelectionButton, onClick: clearSelection, title: "Clear Selection", "data-zds": true },
    react.jsx(components_display_Icon_Icon.Icon, { canAcceptPointerEvents: false, name: "formXCircle", size: 20 })
  );
};
const DateRangePickerInput = (props) => {
  const { value, clearSelection, size } = props;
  const { from, to } = value;
  const hasValue = Boolean(from || to);
  const showClearSelectionButton = hasValue && !props.isDisabled;
  return react.jsx(
    "div",
    { css: Styles.root(props), "data-zds": true },
    react.jsx(components_forms_Input_Input.Input, { id: props.id, isDisabled: props.isDisabled, isErrored: props.isErrored, renderIconAfter: ({ isFocused, isHovered }) => showClearSelectionButton && react.jsx(ClearSelectionButton, { clearSelection, isFocused, isHovered }), renderIconBefore: ({ iconSize }) => react.jsx(components_display_Icon_Icon.Icon, { name: "actionCalendar", size: iconSize }), size }, (inputProps) => (
      // Intentionally `button` and not `Button` since it looks
      // and behaves differently.
      // eslint-disable-next-line jsx-a11y/role-supports-aria-props
      react.jsx("button", { "aria-controls": inputProps["aria-controls"], "aria-expanded": props.isOpen ? "true" : "false", "aria-haspopup": "true", "aria-invalid": inputProps["aria-invalid"], "aria-label": inputProps["aria-label"], "data-size": size, css: [inputProps.css, Styles.button], disabled: inputProps.disabled, id: inputProps.id, onClick: props.onClick, onKeyDown: inputProps.onKeyDown, type: "button", "data-zds": true }, hasValue ? react.jsx(components_forms_DateRangePicker_DateRangePickerValue.DateRangePickerValue, { options: props.options, value: props.value }) : react.jsx("span", { css: Styles.placeholder, "data-zds": true }, props.placeholder))
    ))
  );
};

exports.DateRangePickerInput = DateRangePickerInput;
//# sourceMappingURL=DateRangePickerInput.cjs.js.map
